export default __webpack_public_path__ + "static/media/offer-1.abe131df.jpg";